import {JsonProperty} from '@hyperloris/tyson';

export class BatchUpdateRequest<T> {

  @JsonProperty()
  recordIds?: string[];

  @JsonProperty()
  recordToApply?: T;

  @JsonProperty()
  fieldToUpdate?: string[];

}

